import { i18n } from '@fs/zion-locale'

export default {
  ancestor: () => i18n.t('formInputs.ancestor', 'First Ancestor'),
  ancestralHall: () => i18n.t('formInputs.ancestralHall', 'Ancestral Hall'),
  availableForReview: () => i18n.t('formInputs.availableForReview', 'Available for audit review'),
  availableSince: (date) => i18n.t('formInputs.availableSince', 'Available since {date}', { date }),
  cameraOperatorId: () => i18n.t('formInputs.cameraOperatorId', 'Camera Operator ID'),
  captureId: () => i18n.t('formInputs.captureId', 'Capture ID'),
  clan: () => i18n.t('formInputs.clan', 'Clan'),
  clanBranch: () => i18n.t('formInputs.clanBranch', 'Clan Branch'),
  creator: () => i18n.t('formInputs.creator', 'Creator'),
  custodian: () => i18n.t('formInputs.custodian', 'Custodian'),
  date: () => i18n.t('formInputs.data', 'Date'),
  dgsInstructions: () => i18n.t('formInputs.dgsInstructions', 'Each result has a unique ID number.'),
  generationPoem: () => i18n.t('formInputs.generationPoem', 'Generation Poem'),
  groupIds: () => i18n.t('formInputs.groupIds', 'Group IDs'),
  includeDeprecatedGroups: () => i18n.t('formInputs.includeDeprecatedGroups', 'Are either withdrawn or active'),
  hasRework: () => i18n.t('formInputs.hasRework', 'Have a rework status'),
  imageGroupNumber: () => i18n.t('formInputs.imageGroupNumber', 'Image Group Number (DGS)'),
  imageApid: () => i18n.t('formInputs.imageApid', 'Image APID'),
  imageArk: () => i18n.t('formInputs.imageArk', 'Image ARK'),
  keyword: () => i18n.t('formInputs.keyword', 'Keyword'),
  keywordWarning: () => i18n.t('formInputs.keywordWarning', 'Keywords can limit your results.'),
  learnMore: () => i18n.t('formInputs.learnMore', 'Learn More'),
  lifeEventsDataError: () =>
    i18n.t(
      'formInputs.lifeEventsDataError',
      'The filter for Life Events is currently not working. Please continue with your search or try again later.'
    ),
  lifeEvent: () => i18n.t('formInputs.lifeEvent', 'Life Event'),
  lifeEventPrimaryCheckboxListLabel: () => i18n.t('formInputs.lifeEventPrimaryCheckboxListLabel', 'Try these first:'),
  lifeEventRelatedCheckboxListLabel: () => i18n.t('formInputs.lifeEventRelatedCheckboxListLabel', 'See also:'),
  lifeEventSelectPlaceHolder: () => i18n.t('formInputs.lifeEventSelectPlaceHolder', 'All'),
  mediaNumber: () => i18n.t('formInputs.mediaNumber', 'Media Number'),
  modifiedFromDate: () => i18n.t('formInputs.modifiedFromDate', 'Modified Since'),
  modifiedToDate: () => i18n.t('formInputs.modifiedToDate', 'Modified Before'),
  naturalGroup: () => i18n.t('formInputs.naturalGroup', 'Natural Group ID'),
  needsToBeOrganized: () => i18n.t('formInputs.needsToBeOrganized', 'Need to be organized'),
  place: () => i18n.t('formInputs.place', 'Place'),
  projectId: () => i18n.t('formInputs.projectId', 'Project ID'),
  projectIdHelpMessage: () =>
    i18n.t(
      'internalSearchFields.projectIdHelpMessage',
      'All forms of historical Project IDs and Acquistion IDs accepted.'
    ),
  recordType: () => i18n.t('formInputs.recordType', 'Record Type'),
  recordTypesDataError: () =>
    i18n.t(
      'formInputs.recordTypesDataError',
      'The filter for Record Types is currently not working. Please continue with your search or try again later.'
    ),
  recordTypeWarning: () => i18n.t('formInputs.recordTypeWarning', 'Record Type can limit your results.'),
  surname: () => i18n.t('formInputs.surname', 'Surname'),
  surnamePlaceholder: () => i18n.t('formInputs.surnamePlaceholder', 'Li, Wang, Zhang...'),
  titleNumber: () => i18n.t('formInputs.titleNumber', 'Title Number'),
  before: (date) => i18n.t('formInputs.before', 'before {date}', { date }),
  after: (date) => i18n.t('formInputs.after', 'after {date}', { date }),
  hasMissingCoverageData: () => i18n.t('formInputs.hasMissingCoverageData', 'Have missing coverage data'),
  selectAllPrimary: () => i18n.t('formInputs.selectAllPrimary', 'Select All Primary Record Types'),
  selectAllRelated: () => i18n.t('formInputs.selectAllRelated', 'Select All Related Record Types'),
  weekEndingDate: () => i18n.t('formInputs.weekEndingDate', 'Week Ending Date'),
  dateMustBeInYearFormat: () => i18n.t('formInputs.dateMustBeInYearFormat', 'Dates must be entered as YYYY-MM-DD'),
  weekEndingDatePlaceHolder: () => i18n.t('formInputs.weekEndingDatePlaceHolder', 'YYYY-MM-DD'),
}
